<div *ngIf="!isLoading && beneficiary">
	<section
		class="d-f fd-c w-100 content__mx-h"
		*ngIf="beneficiary?.notifications?.length"
	>
		<div *ngFor="let n of beneficiary?.notifications">
			<article class="d-f jc-sb ai-c w-100 content__mx-h__ntf">
				<span>{{ n.message }}</span>
				<button class="btn-delete" (click)="onDeleteNotification(n.id)">
					<img
						src="../../../../../assets/icons/sanus-close-pink.svg"
						alt="Close message notification"
					/>
				</button>
			</article>
		</div>
	</section>

	<section
		class="d-f fd-c w-100 content__mx-h"
		*ngIf="beneficiary?.cpfDuplicated?.length"
	>
		<div *ngFor="let cpf of beneficiary?.cpfDuplicated">
			<article
				class="d-f jc-sb ai-c w-100 content__mx-h__ntf cpf-duplicated-alert"
			>
				<span
					class="c-p flex-grow-1"
					(click)="onNavigateToDuplicate(cpf)"
					title="Clique para ver o beneficiário"
				>
					<i class="bi bi-exclamation-triangle-fill me-2"></i>
					CPF duplicado com o beneficiário
					<strong>{{ cpf.name }}</strong>
					da organização
					<strong>{{ cpf.organizationName }}.</strong>
				</span>
				<button class="btn-delete" (click)="onCloseCpfDuplicationAlert(cpf)">
					<img
						src="../../../../../assets/icons/sanus-close-pink.svg"
						alt="Fechar alerta de CPF duplicado"
					/>
				</button>
			</article>
		</div>
	</section>

	<div class="d-f jc-sb ai-c w-100 transfer-alert" *ngIf="scheduledTransfer">
		<span>
			<i class="bi bi-info-circle me-2"></i>
			<span *ngIf="!hasDependent">
				Transferência programada: {{ beneficiaryEntity?.user?.name }} será
				transferido para
				{{ scheduledTransfer.toOrganization?.name_secondary }} em
				{{ scheduledTransfer.scheduledDate | date: 'dd/MM/yyyy' }}.
			</span>
			<span *ngIf="hasDependent">
				Transferência programada: {{ beneficiaryEntity?.user?.name }} e o(s)
				dependente(s) serão transferidos para
				{{ scheduledTransfer.toOrganization?.name_secondary }} em
				{{ scheduledTransfer.scheduledDate | date: 'dd/MM/yyyy' }}.
			</span>
		</span>
		<button mat-flat-button color="warn" (click)="cancelScheduledTransfer()">
			<mat-icon>cancel</mat-icon>
			Cancelar
		</button>
	</div>

	<div class="d-f ai-c w-100 inactive-alert" *ngIf="!beneficiary.active">
		<mat-icon svgIcon="sanus-alert-gray"></mat-icon>
		<p>Beneficiário {{ beneficiaryType }}</p>
	</div>
	<div
		class="d-f jc-sb br-md w-100 banner {{
			beneficiary.active ? '' : 'inactive'
		}}"
	>
		<div class="d-f fd-c pl-xxxs pt-xxs info">
			<p
				class="mr-xxs fs-md lh-md fw-bold to-ellipsis {{
					beneficiary.active ? '' : 'low-black'
				}}"
			>
				{{ beneficiary.user.name.toCapitalizedCase() }}
			</p>
			<p class="mr-xxs mt-xxs lh-sm gray to-ellipsis">
				{{
					'CPF: ' +
						(beneficiary.user.cpf | mask: '000.000.000-00') +
						' | ' +
						(isTitular() ? 'Titular' : 'Dependente')
				}}
			</p>

			<p
				class="mr-xxs mt-xxs lh-sm gray to-ellipsis"
				*ngIf="
					beneficiary.user?.phone &&
					formattedPhone(beneficiary.user?.phone).length > 11
				"
			>
				{{ beneficiary.user.email }} |
				{{
					formattedPhone(beneficiary.user.phone)
						| mask: phoneMask(beneficiary.user.phone)
				}}
			</p>
			<p
				class="mr-xxs mt-xxs lh-sm gray to-ellipsis"
				*ngIf="
					beneficiary.user?.phone &&
					formattedPhone(beneficiary.user?.phone).length < 12
				"
			>
				{{ beneficiary.user.email }} |
				{{
					formattedPhone(beneficiary.user.phone)
						| mask: phoneMask(beneficiary.user.phone)
				}}
			</p>
			<div id="beneficiary-action-buttons">
				<button mat-flat-button color="primary" (click)="onEditRegistration()">
					<mat-icon>id_card</mat-icon>
					Cadastro
				</button>

				<button mat-flat-button color="primary" (click)="onShowLog()">
					<mat-icon>list_alt</mat-icon>
					Histórico
				</button>

				<button
					mat-flat-button
					color="primary"
					(click)="onOpenTransferModal()"
					*ngIf="canTransfer"
				>
					<mat-icon>swap_horiz</mat-icon>
					Transferir
				</button>
			</div>
		</div>
		<div class="no-mob">
			<img
				class="image"
				src="../../../../../assets/images/people.svg"
				alt="people"
			/>
		</div>
	</div>
	<div class="d-f jc-sb mt-xxs mb-xxs group">
		<div class="br-md card half">
			<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs mr-xxxs br-md">
				<div class="d-f jc-sb ai-c mb-xxs">
					<span class="fs-sm fw-bold lh-sm to-ellipsis">Benefícios</span>
					<div
						class="d-f jc-c ai-c mr-nano c-p squared"
						(click)="onBenefitsModalOpen()"
					>
						<mat-icon svgIcon="sanus-edit-blue"></mat-icon>
					</div>
				</div>
				<div
					*ngIf="isLoadingBenefits"
					class="d-f jc-c ai-c"
					style="min-height: 150px"
				>
					<mat-spinner diameter="20"></mat-spinner>
				</div>
				<div *ngIf="!isLoadingBenefits">
					<div class="d-f fd-c gap-lg">
						<ng-container *ngFor="let wallet of benefitWallets">
							<div
								[ngClass]="{
									'congener-wallet-wrapper': wallet.type === 'CONGENER',
								}"
							>
								<span *ngIf="wallet.type === 'CONGENER'" class="congener-label">
									Benefício Congênere
								</span>

								<div class="d-f line wallet-content-line">
									<div class="d-f fd-c a">
										<p
											class="fs-xxxs fw-bold gray d-f ai-c"
											style="height: 40px"
										>
											{{ wallet.is_health ? 'Plano de saúde' : 'Plano dental' }}
										</p>
										<p
											class="mt-xxxs fs-xs lh-sm to-ellipsis"
											*ngIf="wallet.not_aplicable"
										>
											Benefício não aplicável
										</p>
										<p
											class="d-f ai-c mt-xxxs fs-xs lh-sm to-ellipsis"
											*ngIf="wallet.benefit_id && !wallet.not_aplicable"
										>
											{{ wallet.name }}
										</p>
										<p
											class="fs-xxxs partner-name gray"
											*ngIf="wallet.partner_name && !wallet.not_aplicable"
										>
											{{ wallet.partner_name }}
										</p>
										<div
											class="d-f ai-c mt-xxxs fs-xs"
											*ngIf="!wallet.not_aplicable && !wallet.benefit_id"
										>
											<mat-icon svgIcon="sanus-alert-red"></mat-icon>
											<p class="margin-top-3">&nbsp; Pendente</p>
										</div>
									</div>

									<div class="d-f fd-c b mob-mt">
										<div class="d-f ai-c gap-md" style="height: 40px">
											<p class="fs-xxxs fw-bold gray">Carteirinha</p>
											<mat-chip-set *ngIf="wallet.type === 'CONJUGATED'">
												<mat-chip
													class="fs-xxxs conjugated-chip"
													color="primary"
													selected
													matTooltip="Este benefício é conjugado (Saúde + Dental). A exclusão de um removerá ambos."
												>
													Conjugado
												</mat-chip>
											</mat-chip-set>
										</div>
										<p
											class="d-f ai-c mt-xxxs fs-xs lh-sm to-ellipsis"
											*ngIf="
												wallet.wallet_number &&
												wallet.benefit_id &&
												!wallet.not_aplicable
											"
										>
											{{ wallet.wallet_number }}
										</p>
										<p
											class="mt-xxxs fs-xs lh-sm to-ellipsis"
											*ngIf="wallet.not_aplicable"
										>
											Benefício não aplicável
										</p>
										<div
											class="d-f ai-c mt-xxxs fs-xs lh-sm"
											*ngIf="
												!wallet.not_aplicable &&
												(!wallet.benefit_id ||
													(wallet.benefit_id && !wallet.wallet_number))
											"
										>
											<mat-icon svgIcon="sanus-alert-red"></mat-icon>
											<p class="margin-top-3">&nbsp; Pendente</p>
										</div>
									</div>

									<div
										*ngIf="wallet.benefit_id"
										class="d-f jc-c ai-c mr-nano c-p squared"
										[class.invisible]="wallet.hideDeleteButton"
										(click)="
											!wallet.hideDeleteButton && onDeleteBenefitModal(wallet)
										"
									>
										<mat-icon svgIcon="sanus-trash-blue"></mat-icon>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
					<div class="d-f jc-c ai-c mt-xxxs">
						<button
							mat-stroked-button
							color="primary"
							class="mt-xxxs"
							(click)="addCongenerPlan()"
						>
							Adicionar Plano Congênere
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="br-md card half mob-mt">
			<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
				<div class="d-f jc-sb ai-c mb-xxs">
					<span class="fs-sm fw-bold lh-sm to-ellipsis">Políticas</span>
					<div
						class="d-f jc-c ai-c mr-nano c-p squared"
						(click)="onPoliciesModalOpen()"
					>
						<mat-icon svgIcon="sanus-edit-blue"></mat-icon>
					</div>
				</div>
				<div class="d-f fd-c gap-lg">
					<div class="d-f line">
						<div class="d-f fd-c">
							<p class="fs-xxxs fw-bold gray">Política de saúde</p>
							<p
								class="d-f ai-c mt-xxxs fs-xs lh-sm to-ellipsis"
								*ngIf="
									healthPolicyData &&
									healthPolicyData?.name &&
									!healthPolicyData.not_aplicable
								"
							>
								{{ healthPolicyData.name }}
							</p>
							<div
								class="d-f ai-c mt-xxxs fs-xs lh-sm"
								*ngIf="
									!healthPolicyData?.name && !healthPolicyData?.not_aplicable
								"
							>
								<mat-icon svgIcon="sanus-alert-red"></mat-icon>
								<p class="margin-top-3">Pendente</p>
							</div>
							<div
								class="d-f ai-c mt-xxxs fs-xs lh-sm"
								*ngIf="healthPolicyData?.not_aplicable"
							>
								<p class="margin-top-3 to-ellipsis">Não há política de saúde</p>
							</div>
						</div>
					</div>
					<div class="d-f mb-xxxs line">
						<div class="d-f fd-c">
							<p
								id="dental-policy-label"
								class="fs-xxxs fw-bold gray"
								[ngClass]="[
									healthBenefitData?.partner_name ? 'dental-policy-label' : '',
								]"
							>
								Política dental
							</p>
							<p
								class="d-f a-ic mt-xxxs fs-xs lh-sm to-ellipsis"
								*ngIf="
									dentalPolicyData &&
									dentalPolicyData?.name &&
									!dentalPolicyData.not_aplicable
								"
							>
								{{ dentalPolicyData.name }}
							</p>
							<div
								class="d-f ai-c mt-xxxs fs-xs lh-sm"
								*ngIf="
									!dentalPolicyData?.name && !dentalPolicyData?.not_aplicable
								"
							>
								<mat-icon svgIcon="sanus-alert-red"></mat-icon>
								<p class="margin-top-3">Pendente</p>
							</div>
							<div
								class="d-f ai-c mt-xxxs fs-xs lh-sm"
								*ngIf="dentalPolicyData?.not_aplicable"
							>
								<p class="margin-top-3 to-ellipsis">Não há política dental</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f jc-sb ai-c mb-xxs">
				<span class="fs-sm fw-bold lh-sm to-ellipsis">
					{{ isTitular() ? 'Dependentes' : 'Titular' }}
				</span>
				<div
					class="d-f jc-c ai-c mr-nano c-p squared"
					*ngIf="isTitular()"
					(click)="onDependentModalOpen(null)"
				>
					<mat-icon svgIcon="sanus-add-blue"></mat-icon>
				</div>
			</div>
			<div id="section-titular" *ngIf="!isTitular()">
				<p>
					<a routerLink="{{ getTitularUrl() }}" id="titular-link">
						{{ beneficiary.titular?.name }}
					</a>
				</p>
			</div>
			<div
				class="d-f jc-sb ai-c w-100 mt-nano mb-xxs m-d"
				*ngIf="isTitular() && !beneficiary?.dependents?.length"
			>
				<span class="fs-i gray">Nenhum dependente cadastrado</span>
			</div>
			<div *ngFor="let dependent of beneficiary.dependents; let index = index">
				<app-dependent-info
					[dependent]="dependent"
					[beneficiaryType]="beneficiaryType"
					[organizationId]="organizationId"
					(editDependent)="onDependentModalOpen($event)"
					(editBenefits)="onDependentBenefitModalOpen($event)"
					(deleteDependent)="onDeleteDependent($event)"
				></app-dependent-info>
			</div>
		</div>
	</div>
	<div class="mt-xxs mb-xxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f fd-c mb-xxs">
				<span class="fs-sm fw-bold lh-md to-ellipsis">Anexos</span>
				<mat-spinner
					diameter="14"
					class="margin-left-8"
					*ngIf="isLoadingFiles"
				></mat-spinner>
			</div>
			<div
				class="pos-r files-container {{ filesOverA ? 'hover' : '' }}"
				(dragover)="onDraggedFiles($event)"
				(dragleave)="onLeaveDraggedFiles($event)"
				(drop)="onDroppedFiles($event)"
			>
				<label
					for="inputA"
					class="d-f fd-c jc-c ai-c bg {{
						beneficiary.files ? (beneficiary.files.length ? 'hide' : '') : ''
					}}"
				>
					<img src="../../../../../assets/images/upload.svg" alt="upload" />
					<p class="mt-xxxs mr-xxxs fs-xxs lh-xs ta-c up-text">
						Clique aqui ou se preferir arraste os arquivos para esta janela
					</p>
					<p class="mt-xxxs fs-xxxs lh-xs ta-c up-text">
						{{ extensionsMessage }}
					</p>
					<p class="mt-quark fs-xxxs lh-xs ta-c up-text">
						{{ fileSizeLabel }}
					</p>
					<p class="mt-quark fs-xxxs lh-xs ta-c up-text">
						{{ maxFilesPerUploadMessage }}
					</p>
				</label>
				<input
					class="file-input"
					type="file"
					id="inputA"
					[multiple]="true"
					(change)="onAddFiles($event)"
				/>
				<div class="d-f f-w files">
					<div class="ph"></div>
					<div
						class="mr-nano mb-xxxs ml-nano pt-quark item"
						*ngFor="let eFA of beneficiary.files; let idx = index"
						(click)="onFileDownload(eFA.key!)"
					>
						<div class="d-f jc-fe" *ngIf="isDeleteButtonVisible">
							<button class="mr-quark" (click)="onRemoveFile(eFA.id, $event)">
								<svg
									class=""
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M12 20.0001C16.4183 20.0001 20 16.4183 20 12.0001C20 7.58178 16.4183 4.00006 12 4.00006C7.58172 4.00006 4 7.58178 4 12.0001C4 16.4183 7.58172 20.0001 12 20.0001ZM12 22.0001C17.5228 22.0001 22 17.5229 22 12.0001C22 6.47721 17.5228 2.00006 12 2.00006C6.47715 2.00006 2 6.47721 2 12.0001C2 17.5229 6.47715 22.0001 12 22.0001Z"
										fill="#9F9F9F"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M8.29296 8.29295C8.68348 7.90243 9.31665 7.90243 9.70717 8.29296L12 10.5858L14.2928 8.29296C14.6834 7.90243 15.3165 7.90243 15.707 8.29295C16.0976 8.68347 16.0976 9.31664 15.7071 9.70716L13.4142 12L15.7071 14.293C16.0976 14.6835 16.0976 15.3166 15.7071 15.7072C15.3166 16.0977 14.6834 16.0977 14.2929 15.7072L12 13.4143L9.70711 15.7072C9.31659 16.0977 8.68342 16.0977 8.2929 15.7072C7.90237 15.3166 7.90237 14.6835 8.29289 14.293L10.5858 12L8.29295 9.70716C7.90243 9.31664 7.90243 8.68347 8.29296 8.29295Z"
										fill="#9F9F9F"
									/>
								</svg>
							</button>
						</div>
						<div
							class="d-f jc-c mt-nano mb-xxs"
							[ngClass]="isDeleteButtonVisible ? '' : 'icon-file'"
						>
							<svg
								width="36"
								height="36"
								viewBox="0 0 36 36"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M4.5 13.5C4.5 8.52944 8.52944 4.5 13.5 4.5L22.5 4.5C27.4706 4.5 31.5 8.52943 31.5 13.5L31.5 22.5C31.5 27.4706 27.4706 31.5 22.5 31.5L13.5 31.5C8.52944 31.5 4.5 27.4706 4.5 22.5L4.5 13.5ZM13.5 7.5C10.1863 7.5 7.5 10.1863 7.5 13.5L7.5 22.5C7.5 25.8137 10.1863 28.5 13.5 28.5L22.5 28.5C25.8137 28.5 28.5 25.8137 28.5 22.5L28.5 13.5C28.5 10.1863 25.8137 7.5 22.5 7.5L13.5 7.5Z"
									fill="#3F55E3"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M12 18C12 17.1716 12.6716 16.5 13.5 16.5L22.5 16.5C23.3284 16.5 24 17.1716 24 18C24 18.8284 23.3284 19.5 22.5 19.5L13.5 19.5C12.6716 19.5 12 18.8284 12 18Z"
									fill="#3F55E3"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M12 24C12 23.1716 12.6716 22.5 13.5 22.5L18 22.5C18.8284 22.5 19.5 23.1716 19.5 24C19.5 24.8284 18.8284 25.5 18 25.5L13.5 25.5C12.6716 25.5 12 24.8284 12 24Z"
									fill="#3F55E3"
								/>
							</svg>
						</div>
						<div class="d-f jc-c mr-quark ml-quark">
							<span class="fs-xxs lh-xs to-ellipsis">{{ eFA?.name }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="mb-xxxs mt-xxs mb-huge br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="cfgForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-sm fw-bold lh-xs to-ellipsis">
					Configurações de beneficiário
				</span>
			</div>
			<p class="mb-xxxs gray">
				Inative se o beneficiário não faz mais parte da companhia
			</p>
			<div class="d-f jc-sb ai-c w-100 mt-xs mb-xxxs">
				<p>Beneficiário ativo</p>
				<mat-slide-toggle
					class="mr-xxxs"
					color="primary"
					formControlName="active"
					(change)="onActivenessChange($event.checked)"
					*ngIf="beneficiaryType === 'ativo'"
				></mat-slide-toggle>
			</div>
			<div
				class="d-f ai-c mb-xxxs mob-date"
				*ngIf="!cfgForm.get('active')!.value"
			>
				<mat-form-field class="mr-xxxs excl-date" appearance="outline">
					<mat-label>Data da exclusão</mat-label>
					<input
						matInput
						placeholder="Data da exclusão"
						formControlName="inactived_at"
						id="sbx-{{ inputId }}"
						[matDatepickerFilter]="dateFilter"
						[matDatepicker]="epicker"
					/>
					<mat-datepicker-toggle matSuffix [for]="epicker">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #epicker></mat-datepicker>
					<mat-hint>
						Data em que o usuário deve ser excluído da seguradora
					</mat-hint>
					<mat-error *ngIf="cfgForm.get('inactived_at')?.hasError('required')">
						Campo obrigatório
					</mat-error>
					<mat-error
						*ngIf="cfgForm.get('inactived_at')?.hasError('matDatepickerFilter')"
					>
						Valor inválido
					</mat-error>
				</mat-form-field>
				<mat-checkbox
					color="primary"
					class="ml-xs mb-nano mob-check"
					formControlName="is_deleted"
				>
					Já foi excluído da seguradora
				</mat-checkbox>
				<mat-form-field class="ml-xxxs excl-date" appearance="outline">
					<mat-label>Data da permanência</mat-label>
					<input
						matInput
						placeholder="Data da permanência"
						formControlName="retired_at"
						id="sblx-{{ inputId }}"
						[matDatepickerFilter]="dateFilter"
						[matDatepicker]="fpicker"
					/>
					<mat-datepicker-toggle matSuffix [for]="fpicker">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #fpicker></mat-datepicker>
					<mat-hint>Aposentado/demitido</mat-hint>
					<mat-error
						*ngIf="cfgForm.get('retired_at')?.hasError('matDatepickerFilter')"
					>
						Valor inválido
					</mat-error>
				</mat-form-field>
				<div class="mob-btn">
					<button
						mat-flat-button
						color="primary"
						[disabled]="cfgForm.invalid"
						(click)="updateBeneficiaryStatus()"
					>
						Salvar
					</button>
				</div>
			</div>
		</div>
	</div>
</div>

<app-transfer-beneficiary-modal
	*ngIf="showTransferModal"
	[beneficiaryId]="beneficiaryId"
	[beneficiaryName]="beneficiaryEntity?.user?.name || ''"
	[currentOrganizationId]="currentBeneficiaryOrganizationId || organizationId"
	[hasDependent]="hasDependent"
	[scheduledTransfer]="scheduledTransfer"
	(close)="showTransferModal = false"
	(success)="onTransferSuccess($event)"
></app-transfer-beneficiary-modal>

<app-cancel-transfer-modal
	*ngIf="showCancelTransferModal"
	[transfer]="scheduledTransfer"
	[beneficiaryName]="beneficiaryEntity?.user?.name || ''"
	[hasDependent]="hasDependent"
	(close)="onCloseCancelTransferModal()"
	(confirm)="onConfirmCancelTransfer()"
></app-cancel-transfer-modal>

<div class="d-f jc-c ai-c w-100 mt-giant loader" *ngIf="isLoading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
